import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const ProgressSpinIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22.5 12c0 5.547-4.301 10.089-9.75 10.474-.413.029-.75.362-.75.776s.337.752.75.727C19.028 23.59 24 18.375 24 12c0-6.627-5.373-12-12-12C5.625 0 .41 4.972.023 11.25A.716.716 0 00.75 12c.414 0 .747-.337.776-.75C1.911 5.8 6.453 1.5 12 1.5c5.799 0 10.5 4.701 10.5 10.5z" />
  </Icon>
);

export default ProgressSpinIcon;
